const toggle = document.getElementById('sidebar-menu-toggle');
const sidebar = document.getElementsByName('communities-sidebar')[0];
const body = document.getElementsByTagName('body')[0];

if (toggle) {
    toggle.addEventListener('click', (e) => {
        sidebar.classList.toggle('sidebar-is-open');
        toggle.classList.toggle('sidebar-is-open');
        body.classList.toggle('sidebar-is-open');
    });
}